import * as React from "react";

export default class Error extends React.PureComponent<{}, {}> {
  render() {
    return <div>Sorry. Something went wrong!</div>;
  }
}
